import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-date-point',
  templateUrl: './date-point.component.html',
  styleUrls: ['./date-point.component.scss']
})
export class DatePointComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
